<template>
  <v-layout row wrap :style="custom">
    <v-flex xs12 sm8 md8 class="reg__custom__flex" style="margin-top: 5px">
      <v-autocomplete
        v-model="selectedTags"
        v-bind:items="tags"
        item-text="name"
        label="Filter"
        multiple
        chips
        return-object
      ></v-autocomplete>
    </v-flex>

    <v-flex xs6 sm2 md2 class="reg__custom__flex" style="margin-top: 15px">
      <v-select :items="['AND', 'OR']" v-model="mode" label="MODE"></v-select>
    </v-flex>

    <v-flex xs6 sm2 md2 class="reg__custom__flex" style="margin-top: 15px">
      <v-select
       
        v-model="group"
        :items="groups"
        item-text="name"
        item-value="id"
        label="Group"
      ></v-select>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    custom : { 
      type: Object
    }

  },
  data() {
    return {
      tags: []
    };
  },
  computed: {
    groups() {
      const groups = [...this.$store.getters.groups];
      groups.push({ name: "All", id: "all", selected: true });
      return groups;
    },
    group: {
      set(v) {
        this.$store.commit("setGroup", v);
        this.calculateFilters();
      },
      get(e) {
        return this.$store.getters.group;
      }
    },
    mode: {
      set(v) {
        this.$store.commit("setMode", v);
      },
      get(e) {
        return this.$store.getters.mode;
      }
    },
    selectedTags: {
      set(v) {
        this.$store.commit("setSelectedTags", v);
      },
      get(e) {
        return this.$store.getters.selectedTags;
      }
    }
  },

  methods: {
    calculateFilters() {
      const self = this;
      this.$http
        .get(`${this.$store.state.endpoint}groups/getTags?&groupId=${this.group}`)
        .then(response => {
          self.tags = response.body;
        });
    }
  },
  async created() {
    /* FILTER COMPONTENT

        The filter compontent will auto polulate its tags based on tags and locations
        It will also emit onchange event and will have default selected value
        The event will also be emitted upon creation

        <user-filter   @change="updateTagAndLocation"></user-filter>

        Handle the change event by accepting a value and assign that value to the data of the parent compontent,
        For example.
        Data : selectedTags

        updateTagAndLocation(tags) {
            if(typeof tags!= "undefined" ) this.selectedTags = tags

            //Now proceed with this.selectedTags
        }

        Signature of tags emitted
        { tags : [ ids of tags ], locations : [ ids of locations ] }

        Use carefully, remember with great power comes great responsibility :P


      */

    const self = this;

    // Generate tags based on groupId
   await self.calculateFilters();



    // this.selectedTags = this.$store.getters.selectedTags

    /* this.tags = this.$store.state.filterState.tags
        this.selectedTags = this.$store.state.filterState.tags
        this.group = = this.$store.state.filterState.group */
  }
};
</script>

<style scoped></style>
